import React, { useEffect, useState, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { useNavigateParams } from '../../../hooks/useNavigateParams';

import { Context } from '../../../context/UserContext';
import Form from './Form';
import styles from '../../form/Form.module.css';

/* hooks */
import useFlashMessage from '../../../hooks/useFlashMessage';

//utils
import * as EmpresaAPI from '../../../api/empresa';
import { lembrarUsuario } from './usuarioPermissao';
import CRUDsAPI from '../../../api/CRUDs';
import * as TabelaAPI from '../../../api/tabela';

import { getEmpresaScope } from '../../../helpers/sessionEmpresa';

const CreateOrEdit = () => {
    const { pessoaId, empresaId, empresaIds } = getEmpresaScope();
    const [dados, setDados] = useState({
        empresaId: empresaId,
        ativo: true,
        visualizar: true,
    });
    const [token] = useState(localStorage.getItem('token')) || '';
    const { parametro } = useContext(Context);

    const [OptionsEmpresa, setEmpresa] = useState([]);
    const [OptionsMenus, setMenus] = useState([]);

    const { setFlashMessage } = useFlashMessage();
    const navigate = useNavigateParams();
    const location = useLocation();
    const urlParams = new URLSearchParams(location.search);

    const pathname = '/Permissoes';
    const ul = urlParams.get('ul');
    const li = urlParams.get('li');
    const tipo = urlParams.get('tipo');
    const operacaoUUID = urlParams.get('operacao');
    const uuid = urlParams.get('uuid');
    const btnText = urlParams.get('btnText') || 'Cadastrar';

    const params = new URLSearchParams({
        ul: ul,
        li: li,
        tipo: tipo,
        operacao: operacaoUUID,
        uuid: uuid,
        btnText: btnText,
    });

    //carregar API's Externas
    const consultaEmpresa = async () => {
        let result = await EmpresaAPI.empresa(empresaId);
        setEmpresa(result);
    };
    const consultaMenu = async () => {
        const result = await TabelaAPI.menu('');
        setMenus(Array.isArray(result) ? result : []);
        if ((!uuid || uuid === 'null') && Array.isArray(result) && result.length) {
            setDados((prev) => ({
                ...prev,
                menuId: result[0].id,
            }));
        }
    };

    useEffect(() => {
        if (!token) {
            return navigate('/Auth', { replace: true });
        }

        consultaEmpresa();
        consultaMenu();

        if (uuid && uuid !== 'null') {
            CRUDsAPI.permissoes
                .consulta(uuid)
                .then((response) => {
                    setDados(response.data);
                })
                .catch((error) => {
                    console.error(error);
                    setFlashMessage(
                        error.response?.data?.message || 'Não foi possível concluir a operação.',
                        error.response?.data?.type || 'error'
                    );
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token, uuid]);

    async function managerDados(dados) {
        let urlNavigate = pathname;

        try {
            let response;

            if (uuid && uuid !== 'null') {
                response = await CRUDsAPI.permissoes.editar(dados);
            } else {
                response = await CRUDsAPI.permissoes.cadastrar(dados);

                if (response.status === 202) {
                    setDados(response.data);
                    response.data.message = 'Registro em duplicidade!';
                    response.data.type = 'warning';
                    urlNavigate = pathname + '/CreateOrEdit';
                    params.set('uuid', response.data.uuid);
                    params.set('btnText', 'Atualizar');
                }
            }

            if (response.status >= 200 && response.status < 300 && response.status !== 202) {
                lembrarUsuario(pessoaId, dados.empresaId, dados.pessoaId);
            }
            setFlashMessage(response.data.message, response.data.type);

            setTimeout(() => {
                navigate(urlNavigate, params);
            }, parametro.msgTempo * 1000);
        } catch (error) {
            console.error(error);
            setFlashMessage(
                error.response?.data?.message || 'Não foi possível concluir a operação.',
                error.response?.data?.type || 'error'
            );
        }
    }
    return (
        <section className={`${styles.form_container} ${styles[parametro.tema]}`}>
            <Form
                token={token}
                dados={dados}
                setDados={setDados}
                pessoaId={pessoaId}
                empresaId={empresaId}
                empresaIds={empresaIds}
                parametro={parametro}
                handleSubmit={managerDados}
                btnText={btnText}
                caminhoVoltar={pathname}
                OptionsEmpresa={OptionsEmpresa}
                OptionsMenus={OptionsMenus}
            />
        </section>
    );
};
export default CreateOrEdit;
